// extracted by mini-css-extract-plugin
module.exports = {"badge":"_1eefbb2c","badgeNeutral":"_94363999","badgeAlert":"_79db98a2","badgeInner":"_efd2e492"};